import { createApi } from '@reduxjs/toolkit/query/react';
import PaginatedResult from '../../types/paginatedResult';
import { buildPaginatedQuery, safeBaseQuery } from './functions';
import { PersonCreateDto, PersonDetailDto, PersonDto } from '../../types/person';

export interface PersonFilters {
    mainLanguageIds?: number[];
    countryIds?: number[];
    createdByIds?: number[];
    companyIds?: number[];
    branchIds?: number[];
    titlePre?: string;
    titlePost?: string;
    name?: string;
    middleName?: string;
    surname?: string;
    status?: string;
}

const person = createApi({
    reducerPath: 'apiPerson',
    baseQuery: safeBaseQuery('person'),
    endpoints: (builder) => ({
        getPersonById: builder.query<PersonDetailDto, number>({
            query: (id) => `/${id}`,
        }),
        getPeople: builder.query<
            PaginatedResult<PersonDto>,
            {
                filters?: PersonFilters;
                page?: number;
                pageSize?: number;
                orderBy?: string;
                asc?: boolean;
            }
        >({
            query: (args = {}) => buildPaginatedQuery<PersonFilters>(args),
        }),
        createPerson: builder.mutation<PersonDetailDto, PersonCreateDto>({
            query: (newPerson) => ({
                url: '/',
                method: 'POST',
                body: newPerson,
            }),
        }),
    }),
});

export const {
    useLazyGetPeopleQuery,
    useGetPeopleQuery,
    useLazyGetPersonByIdQuery,
    useGetPersonByIdQuery,
    useCreatePersonMutation,
} = person;
export default person;
